import { render, staticRenderFns } from "./select-small-boxes.vue?vue&type=template&id=3373dd88&scoped=true&"
import script from "./select-small-boxes.vue?vue&type=script&lang=js&"
export * from "./select-small-boxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3373dd88",
  null
  
)

export default component.exports